






import Vue from 'vue';
import Component from 'vue-class-component';
import DebugWaas from './DebugWaas.vue';

export interface DebugState {
    waas: boolean;
}

function isKeyOf<T extends object>(v: PropertyKey, obj: T): v is keyof T {
    return !!v && v in obj;
}

@Component({ components: { DebugWaas } })
export default class DebugContainer extends Vue {
    debugState: DebugState = {
        waas: false,
    };

    get debugAny(): boolean {
        return Object.values(this.debugState).some(v => v);
    }

    created(): void {
        const queryKeys = (
            new URLSearchParams(window.location.search).get('debug') || ''
        )
            .split(',')
            .map(v => v.trim());

        for (const debugKey of queryKeys) {
            if (isKeyOf(debugKey, this.debugState)) {
                this.debugState[debugKey] = true;
            }
        }
    }
}
